import React from 'react';
import { certTexts } from '../contexts/LangZC';

function ProductZCCertification({ certRef, certVisible, lang = 'ko' }) {
  return (
    <section
      ref={certRef}
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: '#e0e0e0',
        borderRadius: 0,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        marginTop: 40,
        padding: '48px 40px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: '2rem',
        fontWeight: 700,
        color: '#29225C', // 제목 색상 변경
        marginBottom: 16,
        textAlign: 'center', // 가운데 정렬 추가
        width: '100%'        // 부모 div 기준으로 가운데 정렬 적용

      }}>
        {certTexts.title[lang]}
      </span>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        gap: 40,
        alignItems: 'flex-start', // 상단 정렬로 변경
        justifyContent: 'center',
        marginTop: 8,
        width: '100%',
        flexWrap: 'wrap'
      }}>
        {[
          { title: 'CC EAL3+', img: require('../assets/images/primx/cceal3.png') },
          { title: 'ANSSI Security Visa', img: require('../assets/images/primx/security.png') },
          { title: 'EU and NATO Restricted', img: require('../assets/images/primx/eunato.png') },
          { title: 'ENS Alta qualified products', img: require('../assets/images/primx/ens.png') }
        ].map((item, idx) => (
          <div
            key={item.title}
            style={{
              textAlign: 'center',
              width: 220,
              minHeight: 180,
              transition: 'all 0.7s cubic-bezier(0.23, 1, 0.32, 1)',
              opacity: certVisible ? 1 : 0,
              transform: certVisible
                ? 'translateY(0)'
                : 'translateY(40px)',
              transitionDelay: certVisible ? `${idx * 0.12}s` : '0s',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start' // 상단 정렬로 변경
            }}
          >
            <div style={{ fontWeight: 600, color: '#29225C', marginBottom: 8 }}>{item.title}</div>
            <img
              src={item.img}
              alt={item.title}
              style={{
                maxWidth: '100%',
                maxHeight: 120,
                height: 'auto',
                width: 'auto',
                objectFit: 'contain',
                display: 'block'
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProductZCCertification;